import api from './api';

export interface UserAcessos {
  emissoras: number[];
  marcas: number[];
  itens: number[];
  setores: number[];
}

export const AcessosService = {
  /**
   * Obtém os IDs das emissoras, marcas, itens e setores que o usuário logado tem acesso
   * com base nos períodos associados ao seu cliente.
   */
  getUserAcessos: async (): Promise<UserAcessos> => {
    try {
      console.log('[AcessosService] Buscando acessos do usuário logado');
      
      // Use relative path with baseURL
      const response = await api.get('/me/acessos', { 
        baseURL: '/api/v1'
      });
      
      console.log('[AcessosService] Acessos recebidos:', response.data);
      
      return response.data;
    } catch (error: any) {
      console.error('[AcessosService] Erro ao buscar acessos:', error);
      
      // Log detalhado do erro
      if (error.response) {
        console.error('[AcessosService] Erro de resposta:', error.response.data);
        console.error('[AcessosService] Status do erro:', error.response.status);
      } else if (error.request) {
        console.error('[AcessosService] Erro na requisição:', error.request);
      } else {
        console.error('[AcessosService] Mensagem de erro:', error.message);
      }
      
      // Retornar um objeto vazio em caso de erro
      return {
        emissoras: [],
        marcas: [],
        itens: [],
        setores: []
      };
    }
  }
};

export default AcessosService;
